import 'intersection-observer';
import * as React from "react";
import Plyr from 'react-plyr';
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CookieSensitiveContentWrapper } from "../../../../cms/blocks/cookiebar.mod";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";
import { decodeHTMLEntities } from '../../../../../helpers';

export type MediaBlockProps<extra_images> = {
  caption?: string
  useCookieBar: boolean
} & (
  {
    type: 'image'
    image: WordPress.MediaResponse
  } |
  {
    type: 'video'
    video: {
      id: string
      url: string
      type?: 'video' | 'audio' | 'youtube' | 'vimeo'
      contentWidth?: 'content-width' | 'full'
      frameBorder: string
      allowFullScreen: boolean
      hasIntro?: boolean
      hasTitle?: boolean
      intro?: string
      title?: string
    }
  }
)

export type MediaBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string,
  title_classname: string,
  intro_classname: string,
  content_classname: string
  figure_contentwidth_classname: string
  figure_fullwidth_classname: string
  figure_image_classname: string
  figure_video_classname: string
  media_classname: string
  image_classname: string
  placeholder_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  source_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

declare var Optanon;

// This is the block that is used 

export function MediaBlock<CustomBlockData, extra_images>(
  props: MediaBlockProps<extra_images>,
  options?: { style?: MediaBlockStyle; key?: string }
): IOWidget<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  let isFullWidth = true;
  if(props.type == 'video' && props.video.contentWidth == 'content-width') {
    isFullWidth = false;
    console.log(props.video.contentWidth);
  }
  return (cmsState: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: setState => {
        return (
          <section
            className={`block block--media block--${props.type == "image" ? "image" : `video` + (isFullWidth ? ' block--full-width' : '')}`}
          >
            <div className={`block__inner container container--${ props.type == "image" ? "s" : isFullWidth ? 'm' : 's' } gutter--m spacing--m`}>
              <div className="block__content">
                <figure className="block__media">
                  {props.type === 'image' && props.image && (
                    <div className="block__visual">
                      <img
                        src='/frontend/images/empty.png'
                        width={getImageAttribute(props.image, 'media-s', 'width')}
                        height={getImageAttribute(props.image, 'media-s', 'height')}
                        className="block__image border-radius--s lazyload"
                        alt={props.image.alt_text ? props.image.alt_text : ''}
                        data-sizes="auto"
                        data-src={getImageAttribute(props.image, 'media-s', 'source_url')}
                        data-srcset={`${getImageAttribute(props.image, 'media-s', 'source_url')} 700w,
                        ${getImageAttribute(props.image, 'media-m', 'source_url')} 1400w,
                        ${getImageAttribute(props.image, 'media-l', 'source_url')} 2560w`}
                      />
                    </div>
                  )}
                  {props.type == 'video' && props.video && (
                    <>
                      { (props.video.hasTitle || props.video.hasIntro ) && 
                        <div className="block__message">
                          { props.video.hasTitle && 
                          <h2 className="block__title typo--l ff--primary first-item">{ props.video.title }</h2>
                          }
                          { props.video.hasIntro && 
                            <div className="block__intro second-item" dangerouslySetInnerHTML={{ __html: props.video.intro }} />
                          }  
                        </div>
                      }
                      <div className="block__visual">                   
                        {props.useCookieBar ? (
                            <CookieSensitiveContentWrapper
                              groupId={4}
                              options={{
                                style:
                                  options && options.style
                                    ? {
                                        cookies_classname: options.style.cookies_classname,
                                        cookies_inner_classname: options.style.cookies_inner_classname,
                                        cookies_text_classname: options.style.cookies_text_classname,
                                        cookies_clickable_classname: options.style.cookies_clickable_classname
                                      }
                                    : undefined
                              }}
                              placeholder={
                                <div className="media__placeholder spacing--m gutter--m border-radius--s">
                                  <div className="media__inner text--styled">
                                    <p>If you wish to view this video, you need to accept 'Targeting Cookies' as they are required for this functionality.</p>
                                    <p>Please <a className="optanon-toggle-display" onClick={() => Optanon.ToggleInfoDisplay()}>adjust your cookie preferences here</a>.</p>
                                  </div>
                                </div>
                              }
                            >
                              <Plyr
                                // onPlay={() => window.dataLayer.push({
                                //   event: "event.fccorporate", category: "Video", action: "Start", label: window.location.pathname
                                // })}
                                // onPause={() => window.dataLayer.push({
                                //   event: "event.fccorporate", category: "Video", action: "Pause", label: window.location.pathname
                                // })}
                                type={props.video.type}
                                videoId={props.video.url}
                              />
                            </CookieSensitiveContentWrapper>
                          ) : (
                            <Plyr
                              // onPlay={() => window.dataLayer.push({
                              //   event: "event.fccorporate", category: "Video", action: "Start", label: window.location.pathname
                              // })}
                              // onPause={() => window.dataLayer.push({
                              //   event: "event.fccorporate", category: "Video", action: "Pause", label: window.location.pathname
                              // })}
                              type={props.video.type}
                              videoId={props.video.url}
                            />  
                          )}
                      </div>
                    </>
                  )}
                  {props.caption && 
                    <figcaption className="block__caption typo--ms" dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(props.caption) }}/>
                  }
                </figure>
              </div>
            </div>
          </section>
        );
      }
    })
  }
